import React, { createContext, useContext, useState, useEffect } from "react";

const TourContext = createContext();

export const TourProvider = ({ children }) => {
  const [showTour, setShowTour] = useState(() => {
    return JSON.parse(localStorage.getItem("showTour")) || false;
  });

  const [stepIndex, setStepIndex] = useState(() => {
    return parseInt(localStorage.getItem("tourStepIndex")) || 0;
  });


  return (
    <TourContext.Provider value={{ showTour, setShowTour, stepIndex, setStepIndex }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => useContext(TourContext);